import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const SiteListContext = createContext();

const SiteListProvider = ({ children }) => {
  const [slQuery, setSlQuery] = useState('');
  const [slPageValue, setSlPageValue] = useState(1);
  const [slPageSizeValue, setSlPageSizeValue] = useState(10);
  const [slValuesPresent, setSlValuesPresent] = useState(false);
  const [slSortField, setSlSortField] = useState('');
  const [slSortOrder, setSlSortOrder] = useState('');

  const contextValue = useMemo(
    () => ({
      slQuery,
      setSlQuery,
      slPageValue,
      setSlPageValue,
      slPageSizeValue,
      setSlPageSizeValue,
      slValuesPresent,
      setSlValuesPresent,
      slSortField,
      setSlSortField,
      slSortOrder,
      setSlSortOrder,
    }),
    [slQuery, slPageValue, slPageSizeValue, slValuesPresent, slSortOrder, slSortField],
  );

  return <SiteListContext.Provider value={contextValue}>{children}</SiteListContext.Provider>;
};

SiteListProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { SiteListContext, SiteListProvider };
